import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { salisburyConfig } from "./data";

export default function SalisburyPage() {
  return <CityPageTemplate config={salisburyConfig} />;
}